<div class="assets-progress-bar">
  <div class="assets-progress">
    <span>{{ currentAssetCount }} / {{ assetCount }}</span>
  </div>
  <mat-progress-bar mode="determinate" [value]="currentPercent"></mat-progress-bar>
</div>
